import React from "react"
import {
  ContentfulVideoContainer,
  RecordedChatMessageContainer,
  VideoWithChatContainer,
} from "./styles"

const VideoWithChatWrapper = ({ children, recordedChatMessage }) => (
  <VideoWithChatContainer>
    <ContentfulVideoContainer>{children}</ContentfulVideoContainer>

    <RecordedChatMessageContainer>{recordedChatMessage || null}</RecordedChatMessageContainer>
  </VideoWithChatContainer>
)

export default VideoWithChatWrapper
